
/** checks if an email is valid
 * @param {string} email
 * @return {boolean} true if email is valid, false otherwise
 */
function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
export { emailIsValid };